export const dataURL = "/lampid/generali/elenco_lotti";
